module.exports = "./img/ba3c9103d142d755514fd9f87c7c98a7.jpg";